<div class="app-container">
  <aside class="order-sidebar">
    <div class="sidebar-header">
      <div class="header-row">
        <div class="d-flex gap-2 align-items-center">
          <a href="truck?selectedType={{ this.selectedType }}"
            ><svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.75 16.25H18.75C19.1042 16.25 19.401 16.1302 19.6406 15.8906C19.8802 15.651 20 15.3542 20 15C20 14.6458 19.8802 14.349 19.6406 14.1094C19.401 13.8698 19.1042 13.75 18.75 13.75H14.75L15.875 12.625C16.1042 12.3958 16.2188 12.1042 16.2188 11.75C16.2188 11.3958 16.1042 11.1042 15.875 10.875C15.6458 10.6458 15.3542 10.5312 15 10.5312C14.6458 10.5312 14.3542 10.6458 14.125 10.875L10.875 14.125C10.625 14.375 10.5 14.6667 10.5 15C10.5 15.3333 10.625 15.625 10.875 15.875L14.125 19.125C14.3542 19.3542 14.6458 19.4688 15 19.4688C15.3542 19.4688 15.6458 19.3542 15.875 19.125C16.1042 18.8958 16.2188 18.6042 16.2188 18.25C16.2188 17.8958 16.1042 17.6042 15.875 17.375L14.75 16.25ZM15 27.5C13.2708 27.5 11.6458 27.1719 10.125 26.5156C8.60417 25.8594 7.28125 24.9688 6.15625 23.8438C5.03125 22.7188 4.14062 21.3958 3.48438 19.875C2.82812 18.3542 2.5 16.7292 2.5 15C2.5 13.2708 2.82812 11.6458 3.48438 10.125C4.14062 8.60417 5.03125 7.28125 6.15625 6.15625C7.28125 5.03125 8.60417 4.14062 10.125 3.48438C11.6458 2.82812 13.2708 2.5 15 2.5C16.7292 2.5 18.3542 2.82812 19.875 3.48438C21.3958 4.14062 22.7188 5.03125 23.8438 6.15625C24.9688 7.28125 25.8594 8.60417 26.5156 10.125C27.1719 11.6458 27.5 13.2708 27.5 15C27.5 16.7292 27.1719 18.3542 26.5156 19.875C25.8594 21.3958 24.9688 22.7188 23.8438 23.8438C22.7188 24.9688 21.3958 25.8594 19.875 26.5156C18.3542 27.1719 16.7292 27.5 15 27.5Z"
                fill="#004B64"
              />
            </svg>
          </a>
          <h4 class="order-number">{{ truckData?.truckId?.truckNumber }}</h4>
        </div>
      </div>
    </div>
    <hr class="divider" />
    <div class="section-card">
      <div
        class="section-header mb-3 d-flex align-items-center justify-content-between"
      >
        <h4 class="section-title">Truck Details</h4>
      </div>
      <!-- <div class="info-grid d-flex">
        <div class="info-item">
          <p class="info-label">Truck Load date & Time</p>
          <p class="info-value">10:00am 27Oct 2025</p>
        </div>
      </div> -->
      <div class="info-grid">
        <div class="info-item">
          <p class="info-label">Order status</p>
          <p class="info-value success-text">Available</p>
        </div>
      </div>
      <div class="info-grid d-flex">
        <div class="info-item">
          <p class="info-label">Truck in transit date & Time</p>
          <p class="info-value">
            {{ truckData?.updatedAt | date : 'HH:mm ddMMM yyyy' }}
          </p>
        </div>
      </div>
    </div>
    <hr class="divider" />
    <div class="section-card">
      <div
        class="section-header mb-3 d-flex align-items-center justify-content-between"
      >
        <h4 class="section-title">Truck Details</h4>
      </div>
      <div class="d-flex truck-load-detail flex-column gap-3">
        <div class="truck-load-item p-3 rounded-md truck-total-limit">
          <p class="text-body2 font-bold">Total Limit</p>
          <h4 class="text-h4 font-extrabold">{{ truckData.totalLimit }}KG</h4>
        </div>
        <div class="truck-load-item p-3 rounded-md truck-total-available-limit">
          <p class="text-body2 font-bold">Available Limit</p>
          <h4 class="text-h4 font-extrabold">
            {{ truckData.availableLimit }}KG
          </h4>
        </div>
        <div class="truck-load-itemp-3 p-3 rounded-md truck-total-used-limit">
          <p class="text-body2 font-bold">Used Limit</p>
          <h4 class="text-h4 font-extrabold">{{ truckData.usedLimit }}KG</h4>
        </div>
        <button class="btn btn-primary" (click)="intransitp()">
          In transit Truck
        </button>
      </div>
    </div>
  </aside>
  <main class="main-content">
    <h4 class="font-extrabold mb-3">Orders</h4>
    <div class="card-box table-card no-padding">
      <bst-frontend-datatable
        *ngIf="updateDataTable"
        [dataConfig]="dataConfig"
        [dataSourceKey]="page"
        [dataUrl]="nextPageUrl"
      ></bst-frontend-datatable>
    </div>
  </main>
</div>
